import { getToken } from "../utils/token";
import { protectedResources } from "../auth/auth-config";


const getStatus = (response: any, responseType: string = 'json') => {
  if (response.status === 200) {
    if (responseType === 'blob') {
        return response;
    } else if (responseType === 'json') {
        return response.json();
    }
    } else if (response.status === 403) {
      window.location.href = "/AccessDenied"
    }else {
      console.error(`Unexpected response status: ${response.status}`);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  };
  

  

  export const getAPI = async (url: any, responseType?: string, options?: RequestInit) => {
    try{
        const accessToken = await getToken(protectedResources.sherlock.scopes.read)
        const headers= new Headers();
        const bearer = `Bearer ${accessToken}`;
        headers.append("Authorization", bearer);
        const requestOptions: RequestInit = {
          method: "GET",
          headers: headers,
          ...options,  // Merge additional options like 'signal'
      };
        // return fetch(protectedResources.sherlock.baseurl + `${url}`, options)
        // .then((response: any) => {
        //     return getStatus(response)
        // })
        // .then((data: any) => data)
        // .catch((error)=> console.log(error));
        const response = await fetch(protectedResources.sherlock.baseurl + `${url}`, requestOptions);
        if (!response.ok) {
          console.error("Fetch failed with status:", response.status, response.statusText);
          throw new Error(`HTTP error! Status: ${response.status}`);
      }
 
      if (responseType === "blob") {
        return response.blob(); 
      } else {
        return response.json(); 
      }
    } catch (error) {
      console.error("Error occurred during API call:", error);
      throw error;
    }
  };


export const postAPI= async(url:any,postData?:any,responseType:string = 'json',options: RequestInit = {}) => {
  try{
    const accessToken = await getToken(protectedResources.sherlock.scopes.read)
    const bearer =`Bearer ${accessToken}`

    const requestOptions: RequestInit = {
      method:"POST",
      headers:{
        "Content-Type": "application/json",
        Authorization:bearer,
      },
       body:JSON.stringify(postData),
       ...options,
    };
    // 
    const response=await fetch(protectedResources.sherlock.baseurl + `${url}`,requestOptions);
    if(!response.ok){
      console.error("Fetch failed with status:",response.status,response.statusText);
      throw new Error(`HTTP error status:${response.status}`);
    }
    if(responseType === "blob"){
      return response.blob();
    }else if(responseType === "json"){
      return response.json();
    }else{
      throw new Error(`Unsupported response type: ${responseType} `)
    }
  } catch (error:any){
    if (error.name === "AbortError") {
      console.log("Request aborted:", url);
      return;
    }
    console.log("error is ",error);
    throw error;
  }
};
